export default "__VITE_ASSET__HIhW4mgc__"